import { DropdownItem, HFlow, Icon } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import React from 'react'

interface AtividadeColetivaGruposVisualizarDropdownMenuProps {
  readonly onExcluir: () => void
}

export function AtividadeColetivaGruposVisualizarDropdownMenu(
  props: AtividadeColetivaGruposVisualizarDropdownMenuProps
) {
  const { onExcluir } = props

  return (
    <DropdownButton kind='normal' skin='default' size='small'>
      <DropdownItem type='danger' onClick={onExcluir}>
        <HFlow alignItems='center'>
          <Icon icon='trashOutline' />
          Excluir grupo
        </HFlow>
      </DropdownItem>
    </DropdownButton>
  )
}
